import gql from 'graphql-tag';

const DELETE_HASHED_EMAIL_ADDRESS = gql`
  mutation deleteHashedEmailAddress($id: ID!) {
    deleteHashedEmailAddress(where: { id: $id }) {
      id
    }
  }
`;

export default DELETE_HASHED_EMAIL_ADDRESS;
